export class DatasetNodeToolTip {
  datasetId: string;
  datasetName: string;
  dataNodeToolTip: any;
}
